import React, { useState } from 'react';
import { BrowserView } from 'react-device-detect';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import Material from 'Interface/Materiais';
import { useRemoverMaterialMutation } from 'View/Service/Default/Materiais';

import Editar from './Editar';

interface Props {
  dados: Material;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();
  const [modal, setModal] = useState<boolean>(false);
  const [removerMaterial] = useRemoverMaterialMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerMaterial({ id: dados.id }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <React.Fragment>
      <div className="d-flex border-bottom align-items-center py-2 px-3 gap-3">
        <div className="fs-5 text-truncate">
          <span
            className="text-primary cursor-pointer"
            onClick={() => setModal(true)}
          >
            {dados.nome}
          </span>
          <small className="d-block fs-6 text-muted text-truncate">
            <Icone nome="link" className="me-2" />
            {dados.url}
          </small>
        </div>
        <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end gap-5">
          <div className="fs-6 text-end text-nowrap">
            {dados.criado.data().toLocaleString()}
            <small className="d-block fs-6 text-muted">
              <Icone nome="calendar" className="me-2" />
              Criado em
            </small>
          </div>
          <div className="fs-5 text-end d-flex gap-2 align-items-center">
            <Botao
              icone="cloud-arrow-down-fill"
              tema="success"
              onClick={() => window.open(dados.url)}
            />
            <Botao
              icone="trash"
              tema="danger"
              confirmacao="Você tem certeza que deseja remover esse material? Essa ação é irreversivel."
              onClick={remover}
            />
          </div>
        </BrowserView>
      </div>
      <Editar materialId={dados.id} exibir={modal} aoFechar={setModal} />
    </React.Fragment>
  );
};

export default Lista;
